<template>
  <div class="cms_w">
    <div class="content_w bc_FAFAFA">
      <div class="site_content d_flex">
        <div class="side_menu_w bc_fff">
          <div >
            <!-- 栏目标题 -->
            <div class="directory_i">
              <img :src="cmsNode.icon" alt="" />
              <span class="span_1 fz16 c_fff">{{ cmsNode.name || cmsNodeChild.name }}</span>
            </div>

            <!-- 子栏目菜单 -->
            <div
              v-for="item in cmsNode.children"
              :key="item.id"
              class="menu_i_w"
              @click="onNodeClick(item)"
            >
              <div
                class="menu_i c333 fz16"
                :class="Number(cmsNodeChild.id) === item.id ? 'c_0983CC' : ''"
              >
                <span>></span>
                <span class="span_2">{{ item.name }}</span>
              </div>
            </div>
          </div>
        </div>

        <!-- 列表 -->
        <div class="cms_list_w">
          <div ref="mainRef" class="div_2 d_flex flex_direction_col bc_fff">
            <div class="head fz12 c_1A1A1A d_flex justify_content_sb">
              <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item v-if="hasCmsNode">
                  {{ cmsNode && cmsNode.name }}
                </el-breadcrumb-item>
                <el-breadcrumb-item>
                  {{ cmsNodeChild && cmsNodeChild.name }}
                </el-breadcrumb-item>
              </el-breadcrumb>
            </div>
            <div  class="article-list fz16 c_1A1A1A bc_fff">
              <div
                v-if="listData.list && !listData.list.length"
                class="div_3 x_y_center"
              >
                <img src="@/assets/images/empty_icon.png" alt="" />
                <span class="span_2">暂无数据</span>
              </div>

              <ul v-else style="min-height: 500px">
                <li v-for="item in listData.list" :key="item.id" class="li_1">
                  <router-link
                    :to="cmsNodeChild.infoModel.route + `/${item.id}`"
                    class="span_1 text_ellipsis"
                    style="letter-spacing: 1px"
                  >
                    <i class="i_1" />{{ item.title }}
                  </router-link>

                  <span class="c_808080">{{ item.createdAt }}</span>
                </li>
              </ul>
            </div>
          </div>

          <div class="d_flex align_item_c justify_content_c">
            <!--分页-->
            <MyPagination
              :current-page="listData.pageNum"
              :total="listData.total"
              style="margin-top: 8px"
              change-method-name="getListData"
              :that="this"
              layout="total, prev, pager, next, jumper"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Cookies from 'js-cookie'
import { mapGetters } from "vuex";
import MyPagination from "@/components/base/MyPagination.vue";
import { cms_article_list } from "@/api/portal";
import bus from "@/utils/bus";

export default {
  components: {
    MyPagination,
  },
  data() {
    return {
      listData: {},

      pageInfo: {
        page: 1,
        rows: 10,
      },

      cmsNode: {},
      cmsNodeChild: {},
    };
  },
  metaInfo() {
    return {
      title: `${this.cmsNode?.name ? this.cmsNode.name + " - " : ""}${
        this.cmsNodeChild?.name ? this.cmsNodeChild.name + " - " : ""
      }${this.siteInfo?.name}`,
    };
  },
  computed: {
    ...mapGetters(["siteInfo"]),
    hasCmsNode(){
      return Object.keys(this.cmsNode).length
    },
    hasCmsNodeChild(){
      return Object.keys(this.cmsNodeChild).length
    }
  },
  watch: {
    $route: {
      handler(val) {
        this.listData = {};
        if(Object.keys(this.siteInfo).length){
          this.findNode(this.siteInfo.nodes);
          this.getListData(this.pageInfo);
          this.sendState();
        }
      },
      immediate: true,
    },
    siteInfo:{
      handler(n){
        if(Object.keys(n).length){
          this.findNode(this.siteInfo.nodes);
          this.getListData(this.pageInfo);
          this.sendState();
        }
      },
      immediate:true,
      deep:true,
    },
    cmsNodeChild:{
      handler(n){
        if(Object.keys(n).length){
          this.sendState();
        }
      },
      immediate:true,
      deep:true
    }
  },
  created() {

  },
  methods: {
    // 获取当前节点数据 api
    async getListData(params) {
      const { data } = await cms_article_list(
        Object.assign({ code: this.cmsNodeChild.code }, params || this.pageInfo)
      );
      this.listData = data;
    },
    // 查询当前栏目节点和预览子节点
    findNode(nodes, parent) {
      if (nodes && nodes.length) {
        for (const i in nodes) {
          if (nodes[i].id === Number(this.$route.params.id)) {
            this.cmsNode = parent || {};
            this.cmsNodeChild = nodes[i] || {};
            console.log('168',this.cmsNode,this.cmsNodeChild)
            return;
          }
          if (nodes[i].children && nodes[i].children.length) {
            this.findNode(nodes[i].children, nodes[i]);
          }
        }
      }
    },
    // 暴露栏目信息
    sendState() {
      bus.$emit("getCmsNode", this.cmsNode);
      bus.$emit("getCmsNodeChild", this.cmsNodeChild);
    },
    // 点击节点 click
    onNodeClick(item) {
      this.$router.push(item.nodeModel.route + '/' + item.id)
    }
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-breadcrumb {
  font-size: 15px;
}
.cms_list_w {
  flex: 1;

  .head {
    position: absolute;
    width: 100%;
    padding: 19px 20px;
    background: #e6e6e6;
  }
  .li_1 {
    display: flex;
    justify-content: space-between;
    padding: 20px;
    border-bottom: 1px dashed #e6e6e6;
    & .i_1 {
      display: inline-block;
      width: 8px;
      height: 8px;
      background: #b3b3b3;
      border: 1px solid #e6e6e6;
      border-radius: 50%;
      margin: 0 10px 0 0;
    }
    .span_1 {
      max-width: 561px;
      &:hover {
        cursor: pointer;
      }
    }
  }
  .span_2 {
    margin: 0 0 0 10px;
  }
  .article-list {
    height: 100%;
    padding: 52px 0 0 0;
    li {
      &:last-child {
        border: 0;
      }
    }
  }
  .div_2 {
    position: relative;
    overflow: auto;
    border: 1px solid #e6e6e6;

    &::-webkit-scrollbar {
      display: none;
    }
    & {
      scrollbar-width: none; //火狐
    }
  }
  .div_3 {
    min-height: 500px;
  }
  ::v-deep .el-pagination {
    .number,
    .btn-prev,
    .btn-next {
      background-color: transparent;
    }
  }
}

.cms_w {
  margin: 20px 0;
  .content_w {
    padding-top: 15px;
  }
  .side_menu_w {
    width: 216px;
    height: 100%;
    border: 1px solid #dbdbdb;
    margin: 0 10px 0 0;
    .directory_i {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 15px 20px;
      background-color: #0983cc;
    }
    .menu_i {
      display: flex;
      align-items: flex-start;
      padding: 17px 0 17px 20px;
      cursor: pointer;
      border-bottom: 1px solid #e6e6e6;
    }

    .menu_i_w{
      &:last-child {
        .menu_i{
          border-bottom: 0;
        }
      }
    }

  }
  .span_1 {
    margin: 0 0 0 8px;
  }
  .span_2 {
    margin: 0 0 0 20px;
  }
}
</style>
